import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Report } from '../../report';
import { FetchBussinesService } from '../../services/fetch-bussines.service';
import { SellerStatementService } from './seller-statement.service';

@Component({
  selector: 'app-seller-statement',
  templateUrl: './seller-statement.component.html',
  styleUrls: ['./seller-statement.component.scss']
})

export class SellerStatementComponent implements OnInit {
  requestBody: Report = {};
  sellersArray: any[] = [];
  statementReportData: any[] = [];
  totalNumberOfRecords: number = 0;
  bussinesId: number = 0;
  loading = false;
  tableColumns: string[] = [
    'createdAt',
    'transactionType',
    'amount',
    'CumulativeSum', 'refNumber'];

  displayTableColumns = {
    'createdAt': 'Date',
    'transactionType': 'Transaction Type',
    'amount': 'Amount',
    'CumulativeSum': 'Balance',
    'refNumber': 'Transaction Refernce Number'
  };

  constructor(
    protected translate: TranslateService,
    public statmentReportService: SellerStatementService,
    public fetchBussines: FetchBussinesService) {}

  async ngOnInit() {
    this.statmentReportService.activateLoader();
    let response = await this.fetchBussines.make();
    this.sellersArray = response.result;
    this.updateTable();
  }

  async displaySeller(event: any) {
    this.requestBody.selectedID = event;
    this.statmentReportService.setParams(this.requestBody);
    const report = await this.statmentReportService.make();
    this.statementReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  async updateTable() {
    this.statmentReportService.activateLoader();
    this.statmentReportService.setParams(this.requestBody);
    const report = await this.statmentReportService.make();
    this.statementReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  async filter(event: any) {
    console.log('object is', event);
    if (event && Object.keys(event).length) {
      console.log('filter should not be null');
      this.requestBody.filterOptions = event;
    } else {
      console.log('filter should be null');
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.statmentReportService.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.statmentReportService.loader().subscribe(val => (this.loading = val));
  }

  async searchChance(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.statmentReportService.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.statmentReportService.loader().subscribe(val => (this.loading = val));
  }
}
